import { IRootState } from '../../../store'
import { IRelationshipsAndGuarantorsOptionsState } from '../store/options.types'

export const getRelationshipAndGuarantorOptionsSelector = (
  state: IRootState
): IRelationshipsAndGuarantorsOptionsState => state.options.relationshipsAndGuarantorsOptions
